import { FieldActionProps } from './FieldAction.props';

const FieldAction = ({ record, render }: FieldActionProps) => {
  return render(record);
};

export default FieldAction;
